module.exports = __webpack_public_path__ + "img/back-top.d83c5056.svg";